"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ClockIcon = (props) => {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14.1", height: "14.1", viewBox: "0 0 14.1 14.1" },
        react_1.default.createElement("g", { id: "Group_6758", "data-name": "Group 6758", transform: "translate(-461.371 -779.426)" },
            react_1.default.createElement("g", { id: "Group_520", "data-name": "Group 520", transform: "translate(461.421 779.476)" },
                react_1.default.createElement("path", { id: "Path_591", "data-name": "Path 591", stroke: "#000", strokeWidth: "0.1", d: "M69.9,64.219A5.981,5.981,0,1,1,63.918,70.2,5.987,5.987,0,0,1,69.9,64.219m0-1.019a7,7,0,1,0,7,7A7,7,0,0,0,69.9,63.2Zm2.956,10.294a.51.51,0,0,1-.289-.091l-2.89-2a.51.51,0,0,1-.22-.419V66.509a.51.51,0,1,1,1.019,0v4.211l2.672,1.845a.509.509,0,0,1-.291.929Z", transform: "translate(-62.9 -63.2)" })))));
};
exports.default = ClockIcon;
